import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';

/** Shared services */
import { CommonCboService } from './shared/common/commoncbo.service'
import { NotificationService } from './shared/service/notification.service';
import { UtilityService } from './shared/common/utility.service';
import { LoaderService } from './shared/loader/loader.service';
import { LoaderModule } from './shared/loader/loader.module';
import { DataService } from './shared/service/data.service';
import { ErrorService } from './shared/error/error.service';
import { SessionInfo } from './shared/session/SessionInfo';
import { SectionBarModule } from './shared/sectionbar/sectionbar.module';
import { ComunicationService } from './shared/common/comunication.service';
import { SnackbarService } from './shared/snackbar/service/snackbar.service';
import { MatPaginatorIntlCro, MOMENT_DATE_FORMATS } from './shared/common/customClass';
import { MatPaginatorIntl, DateAdapter, MAT_DATE_FORMATS, MatSidenavModule } from '@angular/material';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { LoggingService } from './shared/service/logging.service';
import { OfficeModule } from './modules/security/Office/office.module';
import { RolModule } from './modules/security/Roles/rol.module';
import { UserModule } from './modules/security/user/user.module';
import { AplicacionModule } from './modules/security/Aplicaciones/aplicacion.module';
import { AccessModule } from './modules/security/Accesses/access.module';
import { OfficeAplicacionModule } from '../app/modules/security/officeAplicacion/officeAplicacion.module'
import { RolUserModule } from './modules/security/rolUser/rolUser.module'
import { RolAccessModule } from '../app/modules/security/rolAccess/rolAccess.module'
import { LoginModule } from './modules/security/login/login.module';
import { SidebarModule } from './shared/sidebar/sidebar.module';
import { LandingAplicacionModule } from './modules/landing-aplicacion.module';
import { LandingAccessModule } from './modules/security/landing-access.module';
import { DocumentoModule } from './modules/security/documentos/documento.module';
import { ModuleModule } from './modules/security/modules/module.module';
import { EmpresaModule } from './modules/security/empresa/empresa.module';
import { ConfiguracionInfo } from './shared/configuracion/configuracionInfo';
import { ParametroAutonomiaModule } from './modules/security/parametroAutonomia/parametro-autonomia.module';
import { RolParametroAutonomiaModule } from './modules/security/rolParametroAutonomia/rol-parametro-autonomia.module';
import { RegionModule } from './modules/security/region/region.module';
import { ZonaModule } from './modules/security/zona/zona.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    LoaderModule,
    MatSidenavModule,
    UserModule,
    DocumentoModule,
    SectionBarModule,
    OfficeModule,
    RolModule,
    AplicacionModule,
    AccessModule,
    RolUserModule,
    OfficeAplicacionModule,
    RolAccessModule,
    ModuleModule,
    LoginModule,
    SidebarModule,
    EmpresaModule,
    LandingAplicacionModule,
    LandingAccessModule,
    ParametroAutonomiaModule,
    RolParametroAutonomiaModule,
    RegionModule,
    ZonaModule,
  ],
  providers: [
    DataService, UtilityService, ErrorService, LoggingService, CommonCboService,
    NotificationService, LoaderService, SessionInfo, ComunicationService, SnackbarService, ConfiguracionInfo,
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlCro },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentDateAdapter }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
